export default __webpack_public_path__ + "static/media/briefcase-plus.fead46ae.svg";